export default __webpack_public_path__ + "static/daoism-188c4eaa107bae860e3e1c420f39fc04.png";